<template>
  <v-card class="com-mb-card">
    <v-col class="com-mb-card-contents pa-0">
      <v-col class="px-2">
        <span class="gray--text text--darken-1">{{ text.title }}</span>
      </v-col>
      <v-img src="/kawabou/img/hanrei_hazard_object.png">
        <v-img src="/kawabou/img/hanrei_hazard_base.png" id="hazard_base"></v-img>
      </v-img>
    </v-col>
  </v-card>
</template> 
<script>
export default {
  name: "iu-legend",
  data() {
    return {
      /** 文字列リソース */
      text: {
        title: "浸水深想定イメージ",
      },
    };
  },
  mounted() {
    this.changeOpacity();
  },
  computed: {
    /** 浸水想定図の透過率 */
    inundationOpacity: {
      get() {
        // 不透明度に反転して、パーセント指定を少数に変換して返す
        return (100 - this.$store.state.inundation.inundationOpacity) * 0.01;
      },
    },
  },
  watch: {
    inundationOpacity() {
      this.changeOpacity();
    },
  },
  methods: {
    changeOpacity() {
      var opacity = document.getElementById("hazard_base");
      opacity.style.opacity = this.inundationOpacity;
    },
  },
};
</script>
<style lang="scss" scoped></style>
